import React, { Fragment, useState } from 'react'
import '../styles.scss'
import { Tabs, TabsProps } from 'antd';
import SalesAndService from './SalesAndService';
import SupportHistory from './SupportHistory';
import SurveyInformation from './SurveyInformation';
import MarketingNew from './MarketingNew';
import ModalAddSupportHistory from './ModalAddSupportHistory';

const InteractionHistory = ({ stData = {} as any, stChange = (data: any) => { }, defaultSubTab = undefined as string | undefined }) => {

  const onChange = (key: string) => {
    // setIsTab(Number(key));
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Chăm sóc bán hàng, dịch vụ</span>,
      children: <SalesAndService stData={stData} stChange={(data) => stChange(data)} />,
    },
    {
      key: '2',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử hỗ trợ, khiếu nại</span>,
      children: <SupportHistory stData={stData} stChange={(data) => stChange(data)} />,
    },
    {
      key: '3',
      label: <span className='custom-page-css font-light text-lg'>Thông tin khảo sát</span>,
      children: <SurveyInformation stData={stData} stChange={(data) => stChange(data)} />,
    },
    // {
    //   key: '4',
    //   label: <span className='custom-page-css font-light text-lg'>Marketing</span>,
    //   children: <MarketingNew />,
    // },
  ];


  return (
    <Fragment>

      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative">
          <Tabs defaultActiveKey={defaultSubTab || "1"} items={items} onChange={onChange} className='w-full' />
        </div>
      </div>
    </Fragment>
  )
}
export default InteractionHistory
